// External modules
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ACAuthLoginPage from './components/ac-react-components/login/pages/LoginPage';
import ACAuthLoginCallback from './components/ac-react-components/login/atoms/Callback';

// Internal modules
import { getNevigationItems } from './components/common/global';
import { ReactComponent as AmazingCoLogo } from './medias/Archi.svg';
import MainPage from './components/pages/MainPage';

function Router({ authProperties, config, navigationProperties, errorProperties }) {
    return (
        <Switch>
            <Route
                exact
                path="/login"
                component={(props) => {
                    return (
                        <ACAuthLoginPage
                            authProperties={authProperties}
                            config={config}
                            errorProperties={errorProperties}
                            Logo={AmazingCoLogo}
                            title="Welcome to AEX HQ"
                            subTitle="Login to manage AEX bookings"
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/callback"
                component={(props) => {
                    return <ACAuthLoginCallback authProperties={authProperties} config={config} {...props} />;
                }}
            />
            <Route
                exact
                path="/logout"
                component={(props) => {
                    return (
                        <ACAuthLoginPage
                            authProperties={authProperties}
                            config={config}
                            errorProperties={errorProperties}
                            Logo={AmazingCoLogo}
                            title="Welcome to AEX HQ"
                            subTitle="Login to manage AEX bookings"
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/planner"
                component={(props) => {
                    navigationProperties.selectedNavigationItem = getNevigationItems()[0]; //Planner
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/providers"
                component={(props) => {
                    navigationProperties.selectedNavigationItem = getNevigationItems()[1]; //Providers
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/routes"
                component={(props) => {
                    navigationProperties.selectedNavigationItem = getNevigationItems()[2]; //Routes
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/places"
                component={(props) => {
                    navigationProperties.selectedNavigationItem = getNevigationItems()[3]; //Places
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/moreToExploreCollection"
                component={(props) => {
                    navigationProperties.selectedNavigationItem = getNevigationItems()[4]; //More To Explore
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/sparks"
                component={(props) => {
                    navigationProperties.selectedNavigationItem = getNevigationItems()[5]; //Sparks
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/virtuals"
                component={(props) => {
                    navigationProperties.selectedNavigationItem = getNevigationItems()[6]; //Virtuals
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/"
                component={(props) => {
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
            <Route
                exact
                path="/mx"
                component={(props) => {
                    navigationProperties.selectedNavigationItem = getNevigationItems()[8]; //Micro Experiences
                    return (
                        <MainPage
                            authProperties={authProperties}
                            config={config}
                            navigationProperties={navigationProperties}
                            errorProperties={errorProperties}
                            {...props}
                        />
                    );
                }}
            />
        </Switch>
    );
}

Router.propTypes = {
    authProperties: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    errorProperties: PropTypes.object.isRequired,
    navigationProperties: PropTypes.object.isRequired,
};

Router.defaultProps = {};

export default Router;
